/**
 * Microsoft SharePoint file type icons.
 * Downloaded from: https://static2.sharepointonline.com/files/fabric/assets/item-types/24/
 */

import docx from './docx.svg';
import xlsx from './xlsx.svg';
import pptx from './pptx.svg';
import pdf from './pdf.svg';
import photo from './photo.svg';
import video from './video.svg';
import audio from './audio.svg';
import zip from './zip.svg';
import code from './code.svg';
import html from './html.svg';
import xml from './xml.svg';
import txt from './txt.svg';
import csv from './csv.svg';
import genericfile from './genericfile.svg';
import one from './one.svg';
import vsdx from './vsdx.svg';
import rtf from './rtf.svg';
import email from './email.svg';
import exe from './exe.svg';
import vector from './vector.svg';

export const fileIcons: Record<string, string> = {
  // Microsoft Office
  docx,
  doc: docx,
  docm: docx,
  dot: docx,
  dotx: docx,
  xlsx,
  xls: xlsx,
  xlsm: xlsx,
  xlsb: xlsx,
  pptx,
  ppt: pptx,
  pptm: pptx,
  pps: pptx,
  ppsx: pptx,
  // OneNote
  one,
  onetoc: one,
  onetoc2: one,
  // Visio
  vsdx,
  vsd: vsdx,
  // Documents
  pdf,
  rtf,
  txt,
  md: txt,
  log: txt,
  csv,
  // Images
  photo,
  jpg: photo,
  jpeg: photo,
  png: photo,
  gif: photo,
  bmp: photo,
  webp: photo,
  ico: photo,
  tiff: photo,
  heic: photo,
  // Vector
  vector,
  svg: vector,
  // Video
  video,
  mp4: video,
  avi: video,
  mov: video,
  wmv: video,
  mkv: video,
  webm: video,
  m4v: video,
  flv: video,
  mpeg: video,
  // Audio
  audio,
  mp3: audio,
  wav: audio,
  ogg: audio,
  flac: audio,
  aac: audio,
  m4a: audio,
  wma: audio,
  // Archives
  zip,
  rar: zip,
  '7z': zip,
  tar: zip,
  gz: zip,
  // Code
  code,
  js: code,
  ts: code,
  jsx: code,
  tsx: code,
  json: code,
  py: code,
  java: code,
  cs: code,
  cpp: code,
  c: code,
  h: code,
  go: code,
  rb: code,
  php: code,
  sql: code,
  sh: code,
  ps1: code,
  css: code,
  scss: code,
  less: code,
  // Web
  html,
  htm: html,
  xml,
  // Email
  email,
  msg: email,
  eml: email,
  // Executables
  exe,
  msi: exe,
  // Default
  genericfile,
};

export { genericfile as defaultFileIcon };
